import React, { useContext, useEffect, useState } from "react";
import { DashboardPage } from "./pages/dashboardPage/DashboardPage";
import { LoginPage } from "./pages/loginPage/LoginPage";
import { MeetingPage } from "./pages/meetingPage/MeetingPage";
import { DesktopPage } from "./pages/desktopPage/DesktopPage";
import { SignUpPage } from "./pages/signUpPage/SignUpPage";
import { NotesPage } from "./pages/notesPage/NotesPage";
import { FolderDeepLinkPage } from "./pages/folderPage/FolderDeepLinkPage";
import { HashRouter, Link, Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import { AppController } from "./appController";
import "./app.css";
import { DashboardController } from "./pages/dashboardPage/DashboardController";

const PAGE_TITLES: Record<string, string> = {
    '/login':     'Kitsugi · Login',
    '/sign-up':   'Kitsugi · Sign Up',
    '/dashboard': 'Kitsugi · Dashboard',
    '/desktop':   'Kitsugi · Board',
    '/notes':     'Kitsugi · Notes',
    '/folder':    'Kitsugi · Files',
    '/meeting':   'Kitsugi · Session',
};

const PageTitle: React.FC = () => {
    const location = useLocation();
    useEffect(() => {
        const segment = '/' + location.pathname.split('/')[1];
        document.title = PAGE_TITLES[segment] ?? 'Kitsugi';
    }, [location.pathname]);
    return null;
};

export const App = () => {
    return (
        <HashRouter>
            <PageTitle />
            <AppController>
            <Routes>
                <Route path={'/'} element={<Navigate to="/login" replace />}></Route>
                <Route path={'/test'} element={<div>
                    <div>
                        <Link to="/login">login</Link>
                    </div>
                    <div>
                        <Link to="/sign-up">signUp</Link>
                    </div>
                    <div>
                        <Link to="/dashboard">dashboard</Link>
                    </div>
                    <div>
                        <Link to="/desktop">desktop</Link>
                    </div>
                    <div>
                        <Link to="/meeting/testclientid/testid">meeting</Link>
                    </div>
                </div>}></Route>
                <Route path={'/login'} Component={LoginPage}></Route>
                <Route path={'/dashboard'} element={ <DashboardController><DashboardPage /></DashboardController>}></Route>
                <Route path={'/dashboard/:id'} element={<DashboardController><DashboardPage /></DashboardController>}></Route>
                <Route path={'/sign-up'} Component={SignUpPage}></Route>
                <Route path={'/desktop'} Component={DesktopPage}></Route>
                <Route path={'/notes'} Component={NotesPage}></Route>
                <Route path={'/meeting/:client/:id'} Component={MeetingPage}></Route>
                <Route path={'/folder/:folderId'} Component={FolderDeepLinkPage}></Route>
            </Routes>
            </AppController>
        </HashRouter>
    )
}      
